import React from 'react';
import '../App.css';

function HeadPoseDisplay({ headPose, fps, gazeData }) {
  return (
    <div className="card">
      <h2>📊 Head Pose Data</h2>
      
      <div className="input-group">
        <label>Pitch (X) - Up/Down</label>
        <div className="value-display" style={{ color: '#4caf50' }}>
          {headPose.pitch.toFixed(2)}°
        </div>
      </div>

      <div className="input-group">
        <label>Yaw (Y) - Left/Right</label>
        <div className="value-display" style={{ color: '#2196f3' }}>
          {headPose.yaw.toFixed(2)}°
        </div>
      </div>

      <div className="input-group">
        <label>Roll (Z) - Tilt</label>
        <div className="value-display" style={{ color: '#ff9800' }}>
          {headPose.roll.toFixed(2)}°
        </div>
      </div>

      <div className="input-group">
        <label>FPS</label>
        <div className="value-display" style={{ color: '#9c27b0', fontSize: '1.5em' }}>
          {fps.toFixed(0)}
        </div>
      </div>

      {gazeData && gazeData.distance > 0 && (
        <div className="input-group">
          <label>Distance to Face</label>
          <div className="value-display" style={{ color: '#00bcd4', fontSize: '1.5em' }}>
            {gazeData.distance.toFixed(2)}m
          </div>
        </div>
      )}

      <div style={{ marginTop: '20px', padding: '15px', background: 'rgba(0, 0, 0, 0.2)', borderRadius: '10px' }}>
        <h3 style={{ marginBottom: '10px' }}>Visualization</h3>
        <div style={{ position: 'relative', height: '200px', background: 'rgba(0, 0, 0, 0.3)', borderRadius: '8px', overflow: 'hidden' }}>
          {/* Simple visualization */}
          <div
            style={{
              position: 'absolute',
              left: '50%',
              top: '50%',
              transform: `translate(-50%, -50%) rotateZ(${headPose.roll}deg)`,
              width: '80px',
              height: '80px',
              border: '3px solid #4caf50',
              borderRadius: '50%',
              transition: 'all 0.1s ease'
            }}
          >
            <div
              style={{
                position: 'absolute',
                left: '50%',
                top: '50%',
                transform: `translate(-50%, -50%) translateY(${-headPose.pitch * 2}px) translateX(${headPose.yaw * 2}px)`,
                width: '20px',
                height: '20px',
                background: '#ff9800',
                borderRadius: '50%',
                transition: 'all 0.1s ease'
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default HeadPoseDisplay;
